'use client';

import { MENU_MEGA } from '@/config/layout-9.config';
import { cn } from '@/lib/utils';
import { useMenu } from '@/hooks/use-menu';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu';
import { MegaMenuSubProfiles } from '../../layout-1/shared/mega-menu/mega-menu-sub-profiles';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export function MegaMenu() {
  const pathname = usePathname();
  const { isActive, hasActiveChild } = useMenu(pathname);
  const homeItem = MENU_MEGA[0];
  const publicProfilesItem = MENU_MEGA[1];

  const linkClass = `
    inline-flex flex-row items-center h-12 py-0 border-b border-transparent rounded-none bg-transparent -mb-[1px]
    text-sm text-secondary-foreground font-medium 
    hover:text-mono hover:bg-transparent 
    focus:text-mono focus:bg-transparent 
    data-[active=true]:text-mono data-[active=true]:bg-transparent data-[active=true]:border-mono 
    data-[here=true]:text-mono data-[here=true]:bg-transparent data-[here=true]:border-mono 
    data-[state=open]:text-mono data-[state=open]:bg-transparent 
  `;

  return (
    <NavigationMenu>
      <NavigationMenuList className="gap-2">
        {/* Home Item */}
        {homeItem && (
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <Link
                href={homeItem.path || '/'}
                className={cn(linkClass)}
                data-active={isActive(homeItem.path) || undefined}
              >
                {homeItem.title}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        )}

        {/* Public Profiles Item */}
        {publicProfilesItem && (
          <NavigationMenuItem>
            <NavigationMenuTrigger
              className={cn(linkClass)}
              data-active={
                hasActiveChild(publicProfilesItem.children) || undefined
              }
            >
              {publicProfilesItem.title}
            </NavigationMenuTrigger>
            <NavigationMenuContent className="p-0">
              <MegaMenuSubProfiles items={MENU_MEGA} />
            </NavigationMenuContent>
          </NavigationMenuItem>
        )}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
